var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"closeButton",attrs:{"to":"/"}},[_vm._v("X")])
}
var staticRenderFns = []

export { render, staticRenderFns }